import React, { useState } from 'react';
import './FaqSection.css';

const faqItems = [
  {
    q: "Hvordan ved jeg, om et casino er lovligt i Danmark?",
    a: "Et lovligt dansk casino skal have en gyldig licens fra Spillemyndigheden. Du kan tjekke dette ved at søge på casinoets navn på Spillemyndigheden.dk. Alle casinoer vi omtaler på TopCasinoDansk har dansk licens."
  },
  {
    q: "Hvad er ROFUS, og hvordan bruger jeg det?",
    a: "ROFUS (Register Over Frivilligt Udelukkede Spillere) er et nationalt register, der giver dig mulighed for at udelukke dig fra alle licenserede danske spilsider. Du kan registrere dig på ROFUS.nu – det er gratis og frivilligt. Udelukkelsen gælder øjeblikkeligt for alle deltagende udbydere."
  },
  {
    q: "Hvad er forskellen på de casinoer I omtaler?",
    a: "Vi sammenligner casinoer ud fra en lang række faktorer: spiludvalg, live casino, brugeroplevelse, udbetalingshastighed, kundesupport, bonus-vilkår og ansvarlige spilredskaber. Hvert casino har sine styrker – vores anmeldelser hjælper dig med at finde det, der passer bedst til dig."
  },
  {
    q: "Er I selv et casino?",
    a: "Nej. TopCasinoDansk er en uafhængig guide og sammenligningsportal. Vi tilbyder ikke selv spil, vi accepterer ingen indskud og vi er ikke en spiludbyder. Vi er et redaktionelt medie, der hjælper danske spillere med at navigere i markedet."
  },
  {
    q: "Modtager I provision fra casinoerne?",
    a: "Ja – denne side indeholder affiliate-links. Hvis du besøger et casino via vores links og opretter en konto, kan vi modtage en kommission. Dette påvirker dog ikke vores redaktionelle vurderinger, som er baseret på uafhængige kriterier. Vi anbefaler kun licenserede og seriøse operatører."
  },
  {
    q: "Hvad gør jeg, hvis jeg tror, jeg har et spilleproblem?",
    a: "Det vigtigste første skridt er at erkende det og søge hjælp. Du kan kontakte StopSpillet.dk, som tilbyder gratis og anonym rådgivning, eller ringe til deres hjælpelinje på 70 22 28 25. Du kan også straks selvudelukke dig via ROFUS.nu."
  },
];

function FaqItem({ item, index }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`faq-item${open ? ' faq-item--open' : ''}`}>
      <button
        className="faq-question"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-controls={`faq-answer-${index}`}
      >
        <span>{item.q}</span>
        <span className="faq-icon" aria-hidden="true">{open ? '−' : '+'}</span>
      </button>
      <div
        id={`faq-answer-${index}`}
        className="faq-answer"
        style={{ display: open ? 'block' : 'none' }}
      >
        <p>{item.a}</p>
      </div>
    </div>
  );
}

export default function FaqSection() {
  return (
    <section className="faq-section section">
      <div className="container">
        <div className="faq-layout">
          <div className="faq-intro">
            <div className="divider"></div>
            <h2>Ofte stillede spørgsmål</h2>
            <p>Find svar på de mest almindelige spørgsmål om online casino i Danmark, licenser, ansvarligt spil og vores metode.</p>
          </div>
          <div className="faq-list">
            {faqItems.map((item, i) => (
              <FaqItem key={i} item={item} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
